import React from 'react';
import './DailySchedule.css';

const dailySchedule = [
  {
    time: "03:00 AM",
    event: "Suprabhatam",
    description: "Waking up the Lord",
    icon: "fa-solid fa-sun",
  },
  {
    time: "04:00 AM",
    event: "Thomala Seva",
    description: "Adornment with garlands",
    icon: "fa-solid fa-spa",
  },
  {
    time: "05:30 AM",
    event: "Archana",
    description: "Recitation of holy names",
    icon: "fa-solid fa-om",
  },
  {
    time: "06:00 AM",
    event: "Sarva Darshan",
    description: "General public viewing",
    icon: "fa-solid fa-users",
  },
  {
    time: "12:00 PM",
    event: "Madhyahna Aradhana",
    description: "Mid-day worship",
    icon: "fa-solid fa-hands-praying",
  },
  {
    time: "07:00 PM",
    event: "Ekantha Seva",
    description: "Night service for the Lord",
    icon: "fa-solid fa-moon",
  },
];

function DailySchedule() {
  return (
    <div className="daily-schedule">
      <div className="schedule-header">
        <i className="fas fa-clock"></i>
        <div>
          <h2 className="section-title">Daily Schedule</h2>
          <p className="section-subtitle">Temple timings & rituals</p>
        </div>
      </div>

      <div className="schedule-list">
        {dailySchedule.map((item, index) => (
          <div className="schedule-item" key={index}>
            <div className="schedule-icon">
              <i className={item.icon}></i>
            </div>
            <div className="schedule-time">{item.time}</div>
            <div className="schedule-event">
              <h3>{item.event}</h3>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DailySchedule;